import React from "react";
import { concatClassnames } from "shared/utils/concatClassnames";

export enum RadioVariant {
  BOX,
  CIRCLE,
}

const RADIO_VARIANT_MAPS: Record<RadioVariant, string> = {
  [RadioVariant.BOX]: "gg-w-4 gg-h-4 gg-rounded-sm",
  [RadioVariant.CIRCLE]: "gg-w-4 gg-h-4",
};

interface RadioProps {
  variant: RadioVariant;
  id: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  labelClassName?: string;
  checked?: boolean;
  name?: string;
  children?: any;
  disabled?: boolean;
}

const Radio: React.FC<RadioProps> = ({
  children,
  className = "",
  labelClassName = "",
  id = "",
  onChange,
  checked = false,
  variant,
  name = "",
  disabled = false,
}) => {
  return (
    <label
      htmlFor={id}
      className={concatClassnames("gg-flex gg-items-center ", labelClassName)}
    >
      <input
        id={id}
        className={concatClassnames(
          "gg-form-radio gg-border gg-mr-3 gg-shrink-0",
          disabled && "gg-border-dark-blue-300",
          RADIO_VARIANT_MAPS[variant],
          className
        )}
        type={"radio"}
        onChange={onChange}
        checked={checked}
        name={name}
        disabled={disabled}
      />

      <span>{children ? children : <></>}</span>
    </label>
  );
};

export default Radio;
